<template>
    <div class="tringoContainer">
        <img id="tringo" :src="state.tringoImage" />
        <div id="messageBox" :class="[state.tipVisibility]">
            <p class="unselectable" v-for="(message, index) in tipMsg" :key="index">{{ message }}</p>
        </div>
    </div>
</template>

<script>
import { reactive, watch } from 'vue';
import tringoHappy from '../assets/tringo.png';
import tringoConfused from '../assets/tringo_confused.png';
import tringoSad from '../assets/tringo_sad.png';

export default {
    name: 'Tip',
    props: {
        tipMsg: Array,
        mood: String
    },
    setup(props) {

        /**
         * State object contains tringoImage which tells what imported
         * image to show in template. ShowTip is boolean value and
         * if the tipMsg prop is empty or null, showTip is set to false and
         * the message box is hidden by conditional CSS class.
         *
         * Watch functions are triggered when a change is made from the
         * parent component to props mood or tipMsg.
         */
        const state = reactive({ tringoImage: null, tipVisibility: null });

        watch(() => props.mood, (newValue) => {
            setImage(newValue);
        });

        watch(() => props.tipMsg, (newValue) => {
            setShowTip(newValue);
        });

        const setImage = (newMood) => {

            /**
             * Changes Tringo's image based on the value of
             * prop mood.
             */
            if (newMood === 'happy')
                state.tringoImage = tringoHappy;
            else if (newMood == 'confused')
                state.tringoImage = tringoConfused;
            else if (newMood === 'sad')
                state.tringoImage = tringoSad;
        }

        const setShowTip = (newTipMsg) => {

            /**
             * Sets state.showTip to true or false based on the
             * of prop tipMsg. If tipMsg is empty string or null,
             * set to false and the message box disappears.
             */
            if (newTipMsg !== null || newTipMsg !== '')
                state.tipVisibility = 'visibleMsg';
            else
                state.tipVisibility = 'hiddenMsg';
        }

        setImage(props.mood);
        setShowTip(props.tipMsg);

        return { state, setImage, setShowTip };
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: var(--link_color);
}

p {
    padding: 0em 0.5em 0em 0.5em;
}

.tringoContainer {
    position: absolute !important;
    width: 300px;
    left: -30px;
    top: 12vh;
    z-index: 90;
    background: none;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

#tringo {
    display: inline-block;
    width: 200px;
}

#messageBox {
    display: inline-block;
    position: absolute;
    text-align: left;
    border-radius: 5px;
    background-color: #ccc;
    padding: 0 10px;
    width: 200%;
}

.visibleMsg {
    display: inline;
}

.hiddenMsg {
    display: none;
}

 @media only screen and (max-width: 700px) {
    .tringoContainer {
        transform: scale(0.7);
    }
    .tringoContainer {
    position: absolute !important;
    width: 250px;
    left: -60px;
    top: 6.5vh;
    z-index: 90;
    background: none;
    }
}
 @media only screen and (max-width: 450px) {
    #tringo {
    display: none;
    }
    .tringoContainer {
    position: absolute !important;
    left: -125px;
    margin-left: 10px;
    margin-right: 10px;
    top: 10vh;
    z-index: 90;
    background: none;
    }
}

</style>
